import React from "react"
import {
    computeOrderSupplierItemQuantity,
    generateStockUnitLabel
} from "../../../utils/orderReception"
import DataGrid from "../../../components/DataGrid/DataGrid"
import { makeStyles } from "@mui/styles"

const useStyles = makeStyles({
    top: {
        height: 0,
        marginTop: 0
    },
    root: {
        marginTop: 8
    }
})

const columns = [
    {
        key: "name",
        label: "Nom de l'article",
        dataType: "text",
        sortable: false,
        filter: {
            filterable: true,
            type: "text",
            fullText: true
        }
    },
    {
        key: "reference",
        label: "Référence",
        dataType: "text",
        sortable: false,
        filter: {
            filterable: true,
            type: "text",
            fullText: true
        }
    },
    {
        key: "quantity",
        label: "Quantité réceptionnée / BL",
        dataType: "text",
        sortable: false,
        filter: {
            filterable: false,
        },
        render: (value) => {
            const [receivedQuantity, unit, deliveryNote = 0] = value.split("-").slice(1)
            return (
                <div><span>{receivedQuantity}/{deliveryNote} </span><span style={{ color: "#7C7C7C" }}>({unit})</span></div>
            )
        }
    },
    {
        key: "totalWeight",
        label: "Poids total",
        dataType: "text",
        sortable: false,
        filter: {
            filterable: true,
            type: "text",
            fullText: true
        }
    },
]

const OrderDeliveryNoteSupplierItems = ({ items }) => {
    const classes = useStyles()

    const initialSupplierItems = items?.map((orderSupplierItem) => {
        return {
            id: orderSupplierItem.supplierItem?.objectId,
            name: orderSupplierItem.supplierItem?.name,
            reference: orderSupplierItem.supplierItem?.reference,
            quantity: computeOrderSupplierItemQuantity(orderSupplierItem)
                + "-" + ((orderSupplierItem.quantities?.reception) || "0")
                + "-" + generateStockUnitLabel(orderSupplierItem.supplierItem)
                + "-" + (orderSupplierItem.quantities?.deliveryNote || "0"),
            totalWeight: orderSupplierItem.quantities?.reception * (orderSupplierItem.supplierItem?.units?.stock?.weight || 0)
        }
    }) || []

    return (
        <div className={classes.root}>
            <DataGrid
                columns={columns}
                data={initialSupplierItems}
                withFilters={true}
                rowLabel={null}
                withAdditionalFiltersOptions={false}
                tableContainerStyle={{ boxShadow: "none" }}
                removeDeleteFilterIcon={true}
                topClassName={classes.top}
            />
        </div>
    )
}

export default OrderDeliveryNoteSupplierItems